/** Default EUR → USD rate when no API value is available. */
export const DEFAULT_EUR_USD_RATE = 1.08;

/**
 * Legacy ARS products are treated as EUR amounts during migration.
 */
export function normalizeProductCurrency(currency) {
  const code = String(currency || 'EUR').toUpperCase();
  if (code === 'ARS') return 'EUR';
  if (code === 'EUR' || code === 'USD') return code;
  return 'EUR';
}

export function convertAmount(amount, fromCurrency, toCurrency, eurUsdRate = DEFAULT_EUR_USD_RATE) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return 0;

  const from = normalizeProductCurrency(fromCurrency);
  const to = normalizeProductCurrency(toCurrency);
  if (from === to) return value;

  const rate = Number(eurUsdRate) || DEFAULT_EUR_USD_RATE;
  if (from === 'EUR' && to === 'USD') return value * rate;
  if (from === 'USD' && to === 'EUR') return value / rate;
  return value;
}

export function formatCurrencyAmount(amount, currency) {
  const code = normalizeProductCurrency(currency);
  const value = Number(amount);
  if (!Number.isFinite(value)) {
    return code === 'USD' ? 'USD 0.00' : '€0';
  }

  if (code === 'USD') {
    return `USD ${value.toFixed(2)}`;
  }

  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatProductPrice(amount, productCurrency, displayCurrency, eurUsdRate = DEFAULT_EUR_USD_RATE) {
  const converted = convertAmount(amount, productCurrency, displayCurrency, eurUsdRate);
  return formatCurrencyAmount(converted, displayCurrency);
}

export function getCurrencyPrefix(displayCurrency) {
  return normalizeProductCurrency(displayCurrency) === 'USD' ? 'USD ' : '€';
}
